import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import ConfirmAlertType from '../common/ConfirmAlertType';
import { FOLDING } from '../../data/common';

function ManualImage({
  src = '#',
  alt = '',
  manual = null,
  myManuals = null,
  setIsFolding = () => {},
  setGeneratedPaper = () => {},
}) {
  const navigate = useNavigate();
  const canNavigate = manual !== null && myManuals !== null;
  const isCurrent = manual === null && myManuals === null;
  const [naviConfirmModalOpen, setNaviConfirmModalOpen] = useState(false);

  return (
    <>
      <img
        className="w-[44px] h-[44px] border-[1px] border-[#fff] rounded-[2px] object-cover"
        src={src}
        alt={alt}
        onClick={canNavigate ? () => setNaviConfirmModalOpen(true) : null}
        style={{
          cursor: canNavigate ? 'pointer' : 'default',
          border: isCurrent ? '2px solid #773DBD' : '2px solid #fff',
        }}
      />
      <ConfirmAlertType
        open={naviConfirmModalOpen}
        setOpen={setNaviConfirmModalOpen}
        content={`편집 중인 시험지를 저장하고 교재 이동해주세요.\n교재를 이동하시겠습니까?`}
        cancelLabel="취소"
        confirmLabel="이동"
        onCancel={() => setNaviConfirmModalOpen(false)}
        onConfirm={() => {
          navigate('/vocabulary', {
            state: { manual, myManuals, isExchange: true },
            replace: true,
          });
          setGeneratedPaper([]);
          setIsFolding(FOLDING);
        }}
      />
    </>
  );
}

ManualImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  manual: PropTypes.shape({
    book_imagelink: PropTypes.string,
    book_isbn: PropTypes.string,
    book_title: PropTypes.string,
    cate_lvl1_idx: PropTypes.number,
    cate_lvl2_idx: PropTypes.number,
    created_at: PropTypes.string,
    created_by: PropTypes.number,
    idx: PropTypes.number,
  }),
  myManuals: PropTypes.array,
  setIsFolding: PropTypes.func,
  setGeneratedPaper: PropTypes.func,
};

export default ManualImage;
